import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import './Breadcrumbs.scss';
import { LanguageContext } from '../../../context/language-context';

const Breadcrumbs = ({ route }) => {
  const lng = useContext(LanguageContext);

  const routeNames = route.slice(1).split('/'); // [stores, san-rafael]

  return (
    <ul className="breadcrumbs__list">
      <li className="breadcrumbs__route">
        <NavLink to="/" exact>
          {lng.language === 'en' ? 'home' : 'ホーム'}
        </NavLink>
      </li>
      {routeNames[0] && (
        <li className="breadcrumbs__route">
          <span className="breadcrumbs__direction">&gt;</span>
          <NavLink to={`/${routeNames[0]}`} exact>
            {routeNames[0]}
          </NavLink>
        </li>
      )}
      {routeNames[1] && (
        <li className="breadcrumbs__route">
          <span className="breadcrumbs__direction">&gt;</span>
          <NavLink to={`/${routeNames[0]}/${routeNames[1]}`} exact>
            {routeNames[1].split('-').join(' ')}
          </NavLink>
        </li>
      )}
    </ul>
  );
};

export default Breadcrumbs;
